export const saveToken = (token) => {
  localStorage.setItem('authToken', token);
};

export const getToken = () => {
  return localStorage.getItem('authToken');
};

export const removeToken = () => {
  localStorage.removeItem('authToken');
};

export const saveUserData = (data) => {
  localStorage.setItem('userData', JSON.stringify(data));
};
export const getUserData = () => {
  const data = localStorage.getItem('userData');
  return data ? JSON.parse(data) : null;
};  
export const removeUserData = () => {
  localStorage.removeItem('userData');
};
